import { AccountDetailsGroupsEnum } from '@shared/utils/Enums/AccountDetailsEnum';
import { AccountActivityGroupController } from '../Controllers/AccountControllers/AccountActivityGroupController';
import { GeneralGroupController } from '../Controllers/AccountControllers/GeneralGroupController';
import { InfoGroupController } from '../Controllers/AccountControllers/InfoGroupController';
import { MarginGroupController } from '../Controllers/AccountControllers/MarginGroupController';
import { RiskManagementGroupController } from '../Controllers/AccountControllers/RiskManagementGroupController';
import { TodayResultGroupController } from '../Controllers/AccountControllers/TodayResultGroupController';
export class AccountDetailsControllersDistributor {
    constructor(account) {
        this._account = null;
        this._assetBalance = null;
        this.arrayGroupControllers = [];
        this.generalGroupController = null;
        this.marginGroupController = null;
        this.accountActivityGroupController = null;
        this.todayResultGroupController = null;
        this.riskManagementGroupController = null;
        this.infoGroupController = null;
        this._account = account;
        this._assetBalance = account.assetBalanceDefault;
        this.createGroupControllers();
    }
    get Account() {
        return this._account;
    }
    set Account(value) {
        this._account = value;
        this.AssetBalance = value.assetBalanceDefault;
        this.changeAccountGroupControllers(value);
    }
    get AssetBalance() {
        return this._assetBalance;
    }
    set AssetBalance(value) {
        this._assetBalance = value;
        this.changeAssetBalanceGroupControllers(value);
    }
    createGroupControllers() {
        const account = this.Account;
        const assetBalance = this.AssetBalance;
        this.arrayGroupControllers = [
            (this.generalGroupController = new GeneralGroupController(account, assetBalance)),
            (this.marginGroupController = new MarginGroupController(account, assetBalance)),
            (this.accountActivityGroupController = new AccountActivityGroupController(account, assetBalance)),
            (this.todayResultGroupController = new TodayResultGroupController(account, assetBalance)),
            (this.riskManagementGroupController = new RiskManagementGroupController(account, assetBalance)),
            (this.infoGroupController = new InfoGroupController(account, assetBalance))
        ];
    }
    changeAccountGroupControllers(value) {
        for (const controller of this.arrayGroupControllers) {
            controller.Account = value;
        }
    }
    changeAssetBalanceGroupControllers(value) {
        for (const controller of this.arrayGroupControllers) {
            controller.AssetBalance = value;
        }
    }
    getGroupController(type) {
        switch (type) {
            case AccountDetailsGroupsEnum.General:
                return this.generalGroupController;
            case AccountDetailsGroupsEnum.Margin:
                return this.marginGroupController;
            case AccountDetailsGroupsEnum.AccountActivity:
                return this.accountActivityGroupController;
            case AccountDetailsGroupsEnum.TodayResult:
                return this.todayResultGroupController;
            case AccountDetailsGroupsEnum.RiskManagement:
                return this.riskManagementGroupController;
            case AccountDetailsGroupsEnum.Info:
                return this.infoGroupController;
        }
    }
}
